import RestResource from '../rest.service';

export default class ContactsService extends RestResource {
  map(payload) {
    return {
      contactable_id: payload.contactableId,
      contactable_type: payload.contactableType,
      name: payload.name,
      position: payload.position,
      email: payload.email,
      phone: payload.phone,
    };
  }

  constructor() {
    super('contacts');
  }
}
